export default {
  canSizes: [],
  canSize: undefined,
};
